import { useVisibilityConfig } from '../../utils/useVisibilityConfig';
import { VISIBILITY_KEYS } from '../../utils/constants/visibilityKeys';

// Fail-closed per-PNO gate: a missing key or an unloaded config means off.
export const usePortfolioAskAicaEnabled = () => useVisibilityConfig().isExplicitlyEnabled(VISIBILITY_KEYS.PORTFOLIO_ASK_AICA.ENABLED);
